import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';
import { ChildrenPropType } from '../../prop-types/children';

export const messages = defineMessages({
  name: {
    description: 'modalHotkey.previous',
    defaultMessage: 'Move to the previous window',
    id: 'oZa8BW',
  },
});

export const hotkey = ['ArrowLeft'];
export const barcodeContent = '+CZXJG657Y99V=';

export const GoToPreviousModalHotkey = ({ children = null, onNavigate }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: hotkey,
      hotkey,
      barcode: barcodeContent,
      handler: onNavigate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onNavigate],
  );

  return (
    <>
      <Hotkey hotkey={hotkeyMetadata} />
      {children}
    </>
  );
};

GoToPreviousModalHotkey.propTypes = {
  children: ChildrenPropType,
  onNavigate: PropTypes.func.isRequired,
};
